module.exports = __webpack_public_path__ + "media/images/horses/Horse pregnancy 2nd month.jpg";